const terminalLocOptions = [
  {
    "key": "ON_PREMISE",
    "text": "On premise"
  },
  {
    "key": "OFF_PREMISE",
    "text": "Off premise"
  },
];

export default terminalLocOptions;